import React, { useState } from 'react';
import { Plus, Trash2, Search, Flag, Star } from 'lucide-react';
import { toast } from 'sonner';

// Varsayılan bayraklar (popüler olanlar işaretli)
const DEFAULT_FLAGS = [
  { code: 'PA', name: 'Panama', popular: true },
  { code: 'LR', name: 'Liberia', popular: true },
  { code: 'MH', name: 'Marshall Islands', popular: true },
  { code: 'HK', name: 'Hong Kong', popular: true },
  { code: 'SG', name: 'Singapore', popular: true },
  { code: 'MT', name: 'Malta', popular: true },
  { code: 'BS', name: 'Bahamas', popular: true },
  { code: 'GR', name: 'Greece', popular: true },
  { code: 'CN', name: 'China', popular: true },
  { code: 'JP', name: 'Japan', popular: true },
  { code: 'TR', name: 'Turkey', popular: true },
  { code: 'CY', name: 'Cyprus', popular: true },
  { code: 'IT', name: 'Italy', popular: true },
  { code: 'NO', name: 'Norway', popular: true },
  { code: 'KR', name: 'South Korea', popular: true },
  { code: 'DK', name: 'Denmark', popular: true },
  { code: 'GB', name: 'United Kingdom', popular: true },
  { code: 'US', name: 'United States', popular: true },
  { code: 'AF', name: 'Afghanistan', popular: false },
  { code: 'AL', name: 'Albania', popular: false },
  { code: 'DZ', name: 'Algeria', popular: false },
  { code: 'AR', name: 'Argentina', popular: false },
  { code: 'AU', name: 'Australia', popular: false },
  { code: 'AT', name: 'Austria', popular: false },
  { code: 'AZ', name: 'Azerbaijan', popular: false },
  { code: 'BD', name: 'Bangladesh', popular: false },
  { code: 'BE', name: 'Belgium', popular: false },
  { code: 'BR', name: 'Brazil', popular: false },
  { code: 'BG', name: 'Bulgaria', popular: false },
  { code: 'CA', name: 'Canada', popular: false },
  { code: 'CL', name: 'Chile', popular: false },
  { code: 'CO', name: 'Colombia', popular: false },
  { code: 'HR', name: 'Croatia', popular: false },
  { code: 'CZ', name: 'Czech Republic', popular: false },
  { code: 'EG', name: 'Egypt', popular: false },
  { code: 'EE', name: 'Estonia', popular: false },
  { code: 'FI', name: 'Finland', popular: false },
  { code: 'FR', name: 'France', popular: false },
  { code: 'GE', name: 'Georgia', popular: false },
  { code: 'DE', name: 'Germany', popular: false },
  { code: 'HU', name: 'Hungary', popular: false },
  { code: 'IN', name: 'India', popular: false },
  { code: 'ID', name: 'Indonesia', popular: false },
  { code: 'IR', name: 'Iran', popular: false },
  { code: 'IQ', name: 'Iraq', popular: false },
  { code: 'IE', name: 'Ireland', popular: false },
  { code: 'IL', name: 'Israel', popular: false },
  { code: 'KZ', name: 'Kazakhstan', popular: false },
  { code: 'KW', name: 'Kuwait', popular: false },
  { code: 'LV', name: 'Latvia', popular: false },
  { code: 'LB', name: 'Lebanon', popular: false },
  { code: 'LT', name: 'Lithuania', popular: false },
  { code: 'MY', name: 'Malaysia', popular: false },
  { code: 'MX', name: 'Mexico', popular: false },
  { code: 'MA', name: 'Morocco', popular: false },
  { code: 'NL', name: 'Netherlands', popular: false },
  { code: 'NZ', name: 'New Zealand', popular: false },
  { code: 'NG', name: 'Nigeria', popular: false },
  { code: 'PK', name: 'Pakistan', popular: false },
  { code: 'PE', name: 'Peru', popular: false },
  { code: 'PH', name: 'Philippines', popular: false },
  { code: 'PL', name: 'Poland', popular: false },
  { code: 'PT', name: 'Portugal', popular: false },
  { code: 'QA', name: 'Qatar', popular: false },
  { code: 'RO', name: 'Romania', popular: false },
  { code: 'RU', name: 'Russia', popular: false },
  { code: 'SA', name: 'Saudi Arabia', popular: false },
  { code: 'RS', name: 'Serbia', popular: false },
  { code: 'ZA', name: 'South Africa', popular: false },
  { code: 'ES', name: 'Spain', popular: false },
  { code: 'SE', name: 'Sweden', popular: false },
  { code: 'CH', name: 'Switzerland', popular: false },
  { code: 'TW', name: 'Taiwan', popular: false },
  { code: 'TH', name: 'Thailand', popular: false },
  { code: 'UA', name: 'Ukraine', popular: false },
  { code: 'AE', name: 'United Arab Emirates', popular: false },
  { code: 'VN', name: 'Vietnam', popular: false }
];

const FlagSettings = ({ formData, setFormData }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [newFlag, setNewFlag] = useState({ code: '', name: '', popular: false });
  const [showAddForm, setShowAddForm] = useState(false);

  // Bayrakları al - settings'den veya varsayılanlardan
  const flags = formData.ship_flags || DEFAULT_FLAGS;

  // Bayrakları filtrele
  const filteredFlags = flags.filter(flag =>
    flag.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    flag.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Popüler ve diğer bayrakları ayır
  const popularFlags = filteredFlags.filter(f => f.popular);
  const otherFlags = filteredFlags.filter(f => !f.popular);

  // Bayrak ekle
  const handleAddFlag = () => {
    if (!newFlag.code || !newFlag.name) {
      toast.error('Kod ve isim zorunludur');
      return;
    }

    // Aynı kod veya isim var mı kontrol et
    if (flags.some(f => f.code.toUpperCase() === newFlag.code.toUpperCase())) {
      toast.error('Bu kod zaten mevcut');
      return;
    }

    if (flags.some(f => f.name.toLowerCase() === newFlag.name.toLowerCase())) {
      toast.error('Bu bayrak zaten mevcut');
      return;
    }

    const updatedFlags = [...flags, { 
      code: newFlag.code.toUpperCase(), 
      name: newFlag.name, 
      popular: newFlag.popular 
    }].sort((a, b) => a.name.localeCompare(b.name));

    setFormData({ ...formData, ship_flags: updatedFlags });
    setNewFlag({ code: '', name: '', popular: false });
    setShowAddForm(false);
    toast.success('Bayrak eklendi');
  };

  // Bayrak sil
  const handleDeleteFlag = (code) => {
    if (!window.confirm('Bu bayrağı silmek istediğinizden emin misiniz?')) return;
    
    const updatedFlags = flags.filter(f => f.code !== code);
    setFormData({ ...formData, ship_flags: updatedFlags });
    toast.success('Bayrak silindi');
  };

  // Popüler durumunu değiştir
  const togglePopular = (code) => {
    const updatedFlags = flags.map(f => 
      f.code === code ? { ...f, popular: !f.popular } : f
    );
    setFormData({ ...formData, ship_flags: updatedFlags });
  };

  // Varsayılanlara sıfırla
  const resetToDefaults = () => {
    if (!window.confirm('Tüm bayraklar varsayılana sıfırlanacak. Emin misiniz?')) return;
    setFormData({ ...formData, ship_flags: DEFAULT_FLAGS });
    toast.success('Bayraklar varsayılana sıfırlandı');
  };

  const renderFlagTable = (flagList, title, bgColor) => {
    if (flagList.length === 0) return null;

    return (
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ 
          padding: '0.5rem 1rem', 
          backgroundColor: bgColor, 
          color: 'white',
          borderRadius: '6px 6px 0 0',
          fontWeight: '600',
          fontSize: '0.875rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>{title}</span>
          <span style={{ 
            backgroundColor: 'rgba(255,255,255,0.2)', 
            padding: '0.125rem 0.5rem', 
            borderRadius: '10px',
            fontSize: '0.75rem'
          }}>
            {flagList.length}
          </span>
        </div>
        <div style={{ 
          border: `1px solid ${bgColor}`, 
          borderTop: 'none', 
          borderRadius: '0 0 6px 6px',
          maxHeight: '300px',
          overflowY: 'auto'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <th style={{ padding: '0.5rem', textAlign: 'left', fontSize: '0.75rem', color: '#64748b' }}>Kod</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', fontSize: '0.75rem', color: '#64748b' }}>Bayrak Adı</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.75rem', color: '#64748b' }}>Popüler</th>
                <th style={{ padding: '0.5rem', textAlign: 'center', fontSize: '0.75rem', color: '#64748b' }}>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {flagList.map(flag => (
                <tr key={flag.code} style={{ borderBottom: '1px solid #e2e8f0' }}>
                  <td style={{ padding: '0.5rem', fontSize: '0.875rem', fontWeight: '600' }}>{flag.code}</td>
                  <td style={{ padding: '0.5rem', fontSize: '0.875rem' }}>{flag.name}</td>
                  <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                    <button
                      type="button"
                      onClick={() => togglePopular(flag.code)}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: flag.popular ? '#f59e0b' : '#cbd5e1'
                      }}
                      title={flag.popular ? 'Popülerden çıkar' : 'Popüler yap'}
                    >
                      <Star size={18} fill={flag.popular ? '#f59e0b' : 'none'} />
                    </button>
                  </td>
                  <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                    <button
                      type="button"
                      onClick={() => handleDeleteFlag(flag.code)}
                      className="action-btn action-btn-danger"
                      style={{ padding: '0.25rem 0.5rem' }}
                      title="Sil"
                    >
                      <Trash2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Flag size={20} />
          Gemi Bayrakları Yönetimi
        </h3>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={resetToDefaults}
            style={{ fontSize: '0.875rem' }}
          >
            Varsayılana Sıfırla
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShowAddForm(!showAddForm)}
            style={{ fontSize: '0.875rem' }}
          >
            <Plus size={16} />
            Yeni Bayrak
          </button>
        </div>
      </div>

      {/* Yeni Bayrak Ekleme Formu */}
      {showAddForm && (
        <div style={{ 
          backgroundColor: '#f0fdf4', 
          border: '1px solid #86efac', 
          borderRadius: '8px', 
          padding: '1rem', 
          marginBottom: '1.5rem' 
        }}>
          <h4 style={{ margin: '0 0 1rem 0', fontSize: '0.875rem', color: '#059669' }}>Yeni Bayrak Ekle</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr auto auto', gap: '0.75rem', alignItems: 'end' }}>
            <div>
              <label style={{ fontSize: '0.75rem', color: '#64748b', display: 'block', marginBottom: '0.25rem' }}>Kod *</label>
              <input
                type="text"
                className="form-input"
                placeholder="TR"
                value={newFlag.code}
                onChange={(e) => setNewFlag({ ...newFlag, code: e.target.value.toUpperCase() })}
                maxLength={3}
                style={{ fontSize: '0.875rem' }}
              />
            </div>
            <div>
              <label style={{ fontSize: '0.75rem', color: '#64748b', display: 'block', marginBottom: '0.25rem' }}>Bayrak Adı *</label>
              <input
                type="text"
                className="form-input"
                placeholder="Turkey"
                value={newFlag.name}
                onChange={(e) => setNewFlag({ ...newFlag, name: e.target.value })}
                style={{ fontSize: '0.875rem' }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input
                type="checkbox"
                id="popular-check"
                checked={newFlag.popular}
                onChange={(e) => setNewFlag({ ...newFlag, popular: e.target.checked })}
              />
              <label htmlFor="popular-check" style={{ fontSize: '0.875rem', cursor: 'pointer' }}>Popüler</label>
            </div>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleAddFlag}
              style={{ fontSize: '0.875rem' }}
            >
              Ekle
            </button>
          </div>
        </div>
      )}

      {/* Arama */}
      <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
        <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
        <input
          type="text"
          className="form-input"
          placeholder="Bayrak ara (isim veya kod)..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ paddingLeft: '40px' }}
        />
      </div>

      {/* Toplam */}
      <div style={{ 
        backgroundColor: '#f1f5f9', 
        padding: '0.75rem 1rem', 
        borderRadius: '6px', 
        marginBottom: '1.5rem',
        fontSize: '0.875rem',
        color: '#475569'
      }}>
        Toplam <strong>{flags.length}</strong> bayrak ({popularFlags.length} popüler, {otherFlags.length} diğer)
      </div>

      {/* Bayrak Tabloları */}
      {renderFlagTable(popularFlags, '⭐ Popüler Bayraklar', '#f59e0b')}
      {renderFlagTable(otherFlags, '🌍 Diğer Bayraklar', '#64748b')}

      {filteredFlags.length === 0 && (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>
          Arama sonucu bulunamadı
        </div>
      )}
    </div>
  );
};

export default FlagSettings;
